import { render, staticRenderFns } from "./ai_predefined_prompts.vue?vue&type=template&id=4972c359&"
import script from "./ai_predefined_prompts.vue?vue&type=script&lang=js&"
export * from "./ai_predefined_prompts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports